module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[28]27.ff7a5db.woff2";